import { useApiMutation } from "@/lib/hook";
import { gutter, Modal, MyForm } from "@/theme"
import { Col, Form, Input, Row } from "antd";
import { useEffect } from "react";

export const VideoDetailsModal = ({
    data,
    cancelModal,
    refetch
}) => {
    
    const [form] = Form.useForm();

    useEffect(() => {
        if (data !== 'create') {
            form.setFieldsValue(data)
        }
    }, [data])

    const cancelModalHandler = () => {
        cancelModal()
        form.resetFields();

    }

    const update = useApiMutation({
        onSuccess: () => {
            refetch();
            cancelModalHandler()
        },
    });

    const onFinish = () => {
        const values = form.getFieldsValue()
        update.mutate({
            route: { name: data === 'create' ? "howToVideos.create" : 'howToVideos.update', query: data === 'create' ? null : { id: data.id } },
            data: { ...values },
        });
    };

    return (
        <Modal
            open={data}
            centered
            destroyOnClose={true}
            onCancel={cancelModalHandler}
            title={
                <>
                    <div style={{ fontWeight: "bold" }}>{data==='create' ? 'Create new link' : 'Edit link'}</div>
                </>
            }
            footer={
                <Modal.Buttons
                    okText={data==='create' ? "Add new link" : 'Edit link'}
                    cancelText="Cancel"
                    onOk={onFinish}
                    onCancel={cancelModalHandler}
                    okProps={{ loading: update.isLoading }}
                />
            }
        >
            <MyForm
                // spinning={update.isLoading}
                form={form}
                name="howToVideo"
                autoComplete="off"
                layout="vertical"
            >
                <Row gutter={gutter}>
                    <Col span={24}>
                        <Form.Item name="name" label="Title">
                            <Input placeholder={"Enter link title"} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item name="link" label="Link">
                            <Input placeholder={"Enter link"} />
                        </Form.Item>
                    </Col>
                </Row>
            </MyForm>
        </Modal>
    )
}